import { CircularProgress } from "@mui/material";
import styles from "../../styles/Home.module.css";

export const LoadingPage = () => {
  // console.log("LoadingPage🔥");
  return (
    <main className={styles.main_loading}>
      <div>
        <CircularProgress
          size={40}
          thickness={5} // 円の太さを太くする
          style={{
            animation: "rotate 0.5s linear infinite",
            color: "#FF999E" // 円の色を変更
          }}
        />
      </div>
    </main>
  );
};
